<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <fault-type-group-create-or-update v-model="fault" :errors="errors"></fault-type-group-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FaultTypeGroupCreateOrUpdate from './components/FaultTypeGroupCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        FaultTypeGroupCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Arıza Tipi Ana Grubu",key:"Name", thClass:"w-100",sortable:true},   
                {name:"Sıra",key:"OrderNumber", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            fault:{
                Id:null,
                Name:null,
                OrderNumber:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.fault.Id = null
            this.fault.Name = null
            this.fault.OrderNumber = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.FaultTypeGroup.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.fault.Id = item.Id
            this.fault.Name = item.Name
            this.fault.OrderNumber = item.OrderNumber
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.FaultTypeGroup.CreateOrUpdate(this.editing,this.fault).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} arıza tipi ana grubunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.FaultTypeGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>